import {EventBus} from '@teemill/common/classes';

export const pageBus = new EventBus('pages', {
  crossFrame: true,
});
